var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.65967H9.16675",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.9927H4.16675",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.4927C15.5475 17.4927 16.6667 16.3734 16.6667 14.9927C16.6667 13.612 15.5475 12.4927 14.1667 12.4927C12.786 12.4927 11.6667 13.612 11.6667 14.9927C11.6667 16.3734 12.786 17.4927 14.1667 17.4927Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 9.15967C7.21396 9.15967 8.33325 8.04038 8.33325 6.65967C8.33325 5.27896 7.21396 4.15967 5.83325 4.15967C4.45254 4.15967 3.33325 5.27896 3.33325 6.65967C3.33325 8.04038 4.45254 9.15967 5.83325 9.15967Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconNew);
export default __webpack_public_path__ + "static/media/settings-icon-new.0f046158040aa1a510924a74e0a32daf.svg";
export { ForwardRef as ReactComponent };